import React from "react";
import { Controller } from "react-hook-form";
import { FormGroup, Label, Input } from "reactstrap";
import { InputField } from "../../CommonElements";

const DataDiri = ({ control, watch, preview=false }) => {
  return (
    <div>
      <div className="purple-header mb-4 bg-primary">
        <h3 className="text-white p-3">Data Diri</h3>
      </div>

      <div className="form-section-content">
        <FormGroup style={{border: "1px solid #ccc", padding: "20px", borderRadius: "5px"}}>
          <Controller
            name="nama"
            control={control}
            rules={{ required: "Harap masukkan nama anda" }}
            render={({field, fieldState}) => (
              <InputField
                label="Nama Peserta"
                className="mb-3"
                fieldState={fieldState}
                {...field}
                isRequired
                disabled={watch('submit') | preview}
              />
            )}
          />
        </FormGroup>

        <FormGroup style={{border: "1px solid #ccc", padding: "20px", borderRadius: "5px"}}>
          <Controller
            name="nama_ktp"
            control={control}
            rules={{ required: "Harap masukkan nama sesuai KTP" }}
            render={({field, fieldState}) => (
              <InputField
                label="Nama Untuk Tiket (jika informasi tercantum tidak sesuai, silakan diperbaiki)"
                className="mb-3"
                fieldState={fieldState}
                {...field}
                isRequired
                disabled={watch('submit') | preview}
              />
            )}
          />
        </FormGroup>

        <FormGroup style={{border: "1px solid #ccc", padding: "20px", borderRadius: "5px"}}>
          <Controller
            name="nik"
            control={control}
            rules={{ required: "Harap masukkan NIK sesuai KTP" }}
            render={({field, fieldState}) => (
              <InputField
                label="NIK (Tertulis di KTP) (jika informasi tercantum tidak sesuai, silakan diperbaiki)"
                className="mb-3"
                fieldState={fieldState}
                {...field}
                isRequired
                disabled={watch('submit') | preview}
              />
            )}
          />
        </FormGroup>
      </div>
    </div>
  );
};

export default DataDiri;